import React, { useState, useEffect } from "react";
import { Button} from "react-bootstrap";
import SimpleTable from "my-simple-react-table";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import cogoToast from 'cogo-toast';
import {Card, CardBody, CardHeader, CardHeaderToolbar} from "../../../../../_metronic/_partials/controls";
import { formatAdminType, formatDate, formatStatus } from "../../../../util/Helpers";
import TableSkeleton from "../../../../util/TableSkeleton";
import * as handlers from "../../_redux/admins/adminsHandlers";
import NewAdmin from "./modals/NewAdmin";
import EditAdmin from "./modals/EditAdmin";
import DeleteAdmin from "./modals/DeleteAdmin";

const Admins = () => {
  // Admins Redux state
  const dispatch = useDispatch();
  const userId = useSelector( ({auth:{user}}) => (user.id), shallowEqual);
  // Getting current state of admins list from store (Redux)
  const admins = useSelector(state => (state.admins ), shallowEqual);
  // Modal Operation State
  const [adminsState, setAdminsState] = useState({
                                                showNewModal: false, 
                                                showEditModal: false, 
                                                showDeleteModal: false, 
                                                admin: null
                                              })

  useEffect(() => {
    // Fetch All Admins
    dispatch(handlers.fetchAdmins());
  }, [dispatch]);

  
  /* Notification Pop up */
  useEffect(() => {
    if (admins.notification){
      cogoToast[admins.notification.type](admins.notification.message);
      dispatch(handlers.clearNotification());
    }
  });

  /* Modal show/hide Toggle */
  const toggleModal = modal => _ => {
    setAdminsState({[modal]: !adminsState[modal]})
  }

  /* New Admin Form Submission */
  const addNewAdmin = adminData => {
    dispatch(handlers.addAdmin(adminData));

  }

  /* Admin Edit Modal pop up */
  const adminEditModal = admin => {
    setAdminsState({...adminsState, showEditModal: true, admin})
  }

  /* Edit Admin Form Submission */
  const editAdmin = adminData => {
    dispatch(handlers.updateAdmin(adminData));
  }

  /* Admin Delete Modal pop up */
  const adminDeleteModal = admin => {
    setAdminsState({...adminsState, showDeleteModal: true, admin: admin})
  }

  /* Delete Admin Confirmation */
  const deleteAdmin = id => {
    toggleModal("showDeleteModal")()
    dispatch(handlers.deleteAdmin(id));
  }

  const adminAction = row => {
    
    return (<span style={{whiteSpace: "nowrap"}}>
              <Button
                title="Edit Admin"
                disabled={row.id === userId}
                className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                onClick={_ => adminEditModal(row)}
                
              >
                <span className="svg-icon svg-icon-md svg-icon-primary">
                  <SVG
                    title="Edit Admin"
                    src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                  />
                </span>
              </Button>
          
              <Button
                title="Delete Admin"
                disabled={row.id === userId}
                className="btn btn-icon btn-light btn-hover-danger btn-sm"
                onClick={_ => adminDeleteModal(row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-danger">
                  <SVG 
                    title="Delete Admin"
                    src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} 
                  />
                </span>
              </Button>
            </span>
        )
  }


  return <div className="py-4 px-6">
          <Card>
            <CardHeader title="Admins list">
              <CardHeaderToolbar>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={toggleModal("showNewModal")}
                >
                <span className="svg-icon menu-icon">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Add-user.svg")}/>
                </span>
                  New Admin
                </button>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
            {
              admins.isLoading ? 
              <TableSkeleton/> 
              :
              <SimpleTable 
                data={admins.data} 
                columns={[
                          {title:"NAME", format: row =>  `${row.firstName} ${row.lastName}`},
                          {title:"EMAIL", key: "email"}, 
                          {title:"STATUS", format: row => formatStatus(row.status)}, 
                          {title:"ROLE", format: row => <><span className="label label-dot label-primary mr-2"></span>{formatAdminType(row.adminLevel)}</>}, 
                          {title: "LAST LOGIN", format: row => formatDate(row.lastLogin)},
                          {title: "CREATED AT", format: row => formatDate(row.createdAt)},
                          {title: "ACTIONS", format: adminAction}
                        ]} 
              />
            }        
            </CardBody>
          </Card>

          <NewAdmin 
            show={adminsState.showNewModal}
            onHide={toggleModal("showNewModal")}
            addNewAdmin= {addNewAdmin}
          />

          <EditAdmin
            show={adminsState.showEditModal}
            onHide={toggleModal("showEditModal")}
            editAdmin= {editAdmin}
            admin={adminsState.admin}
          />

          <DeleteAdmin
            show={adminsState.showDeleteModal}
            onHide={toggleModal("showDeleteModal")}
            deleteAdmin= {deleteAdmin}
            admin={adminsState.admin}
          />
        </div>
  
};

export default Admins;
